@if (entry.deposits) {
    <div
        class="cart-item-deposit"
        placement="bottom"
        [ngbPopover]="depositPopover"
        [innerHTML]="
        (!paymentMode.credit || !alreadyOrdered
            ? ('aimo.cart.item.deposits'
              | cxTranslate
                  : {
                        amount: entry.deposits.totalPriceWithTax?.formattedValue,
                        tax: taxRates,
                    })
            : ('aimo.cart.item.depositsNoTax' | cxTranslate))
    |safeHtml"></div>
}

<ng-template #depositPopover>
    @if (!paymentMode.credit || !alreadyOrdered) {
        <p
            class="mb-3"
            [innerHTML]="
            ('aimo.cart.item.depositsText'
                | cxTranslate
                    : {
                          amount: entry.deposits.totalPriceWithTax.formattedValue,
                          tax: taxRates,
                      })|safeHtml">
        </p>
    }
    <ul class="mb-0 pl-3">
        @for (deposit of entry.deposits.entries; track deposit.entryNumber) {
            <li>{{ deposit.product.name }} {{ deposit.quantity }}</li>
        }
    </ul>
</ng-template>
